import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import api from "@/lib/api";
import { ArrowLeft, Wrench, Euro, Clock, History } from "lucide-react";

export default function MachineHistoryPage() {
  const { id } = useParams();
  const nav = useNavigate();
  const [machine, setMachine] = useState(null);
  const [hist, setHist] = useState(null);

  useEffect(() => {
    Promise.all([api.get(`/machines/${id}`), api.get(`/machines/${id}/history`)]).then(([r1, r2]) => {
      setMachine(r1.data); setHist(r2.data);
    });
  }, [id]);

  if (!machine || !hist) return <div className="p-8 text-zinc-500">Caricamento...</div>;

  return (
    <div className="p-4 md:p-8 max-w-6xl mx-auto">
      <button onClick={()=>nav(-1)} className="text-xs uppercase tracking-widest text-zinc-400 hover:text-white mb-3 flex items-center gap-1.5">
        <ArrowLeft size={14} /> Indietro
      </button>

      <div className="mb-6">
        <div className="text-xs uppercase tracking-[0.2em] text-zinc-500 mb-2">Storico macchina</div>
        <h1 className="font-display text-3xl md:text-4xl font-black uppercase tracking-tight">{machine.marca} {machine.modello}</h1>
        <div className="font-mono-data text-[#4CAF50] mt-1">{machine.matricola}</div>
        <div className="text-zinc-400 text-sm">Cliente: {machine.customer?.ragione_sociale || "—"}</div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-6">
        <S label="Interventi totali" value={hist.totale_interventi} icon={History} />
        <S label="Ore lavorate" value={`${hist.totale_ore}h`} icon={Clock} />
        <S label="Ricambi (€)" value={`€ ${hist.totale_ricambi_costo.toFixed(2)}`} icon={Wrench} />
        <S label="Costo totale" value={`€ ${hist.totale_costo.toFixed(2)}`} icon={Euro} highlight />
      </div>

      <div className="gm-card overflow-x-auto">
        <div className="p-5 border-b border-zinc-800">
          <h3 className="font-display text-xl font-bold uppercase tracking-tight">Cronologia interventi</h3>
        </div>
        <table className="gm-table">
          <thead><tr><th>Data</th><th>Numero</th><th>Problema</th><th>Stato</th><th>Tipo</th><th className="text-right">Ore</th><th className="text-right">Ricambi €</th><th className="text-right">Totale €</th></tr></thead>
          <tbody>
            {hist.interventi.length === 0 && (<tr><td colSpan="8" className="text-center text-zinc-500 py-8">Nessun intervento</td></tr>)}
            {hist.interventi.map(w => (
              <tr key={w.id} className="cursor-pointer" onClick={()=>nav(`/schede/${w.id}`)}>
                <td className="font-mono-data text-xs text-zinc-400">{new Date(w.created_at).toLocaleDateString("it-IT")}</td>
                <td className="font-mono-data text-[#4CAF50] font-bold">{w.numero}</td>
                <td className="text-xs max-w-[280px] truncate">{w.descrizione_problema}</td>
                <td><span className="gm-badge gm-badge-muted">{w.stato.replaceAll("_"," ")}</span></td>
                <td className="text-xs text-zinc-400">{w.tipo_garanzia?.replaceAll("_"," ")}</td>
                <td className="text-right font-mono-data">{(w.ore_totali||0).toFixed(1)}h</td>
                <td className="text-right font-mono-data">€ {(w.ricambi_costo||0).toFixed(2)}</td>
                <td className="text-right font-mono-data font-bold">€ {(w.totale||0).toFixed(2)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

const S = ({label, value, icon: Icon, highlight}) => (
  <div className={`gm-card p-4 ${highlight?"border-[#4CAF50]/40 bg-[#4CAF50]/5":""}`}>
    <div className="flex items-start justify-between mb-2">
      <div className="text-[10px] uppercase tracking-widest text-zinc-500">{label}</div>
      {Icon && <Icon size={16} className="text-zinc-600" />}
    </div>
    <div className={`font-display text-2xl font-black ${highlight?"text-[#4CAF50]":""}`}>{value}</div>
  </div>
);
